import { ColoursObj, getContrastYIQ } from '@eventr/common-storybook'
import { Tab, Tabs } from '@mui/material'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGuestStore } from '../../../../../feat/guest/guest.store'
import i18n from '../../../../../i18n/i18next'
import { useBoundStore } from '../../../../../state/bound.store'
import {
    getIdentifierFromHomeTab,
    getTranslationKeyFromHomeTab,
    homeTabs,
} from '../../../../../state/itineraryState/homeTabs'
import { homeTabSignal } from '../../../../../state/itineraryState/itinerarySignals'

export const HomeTabs = () => {
    const isGuestMode = useGuestStore((s) => s.isGuestMode)
    const { disableLocationServices } = useBoundStore(
        useShallow((s) => {
            return {
                disableLocationServices: s.orgConfig.disableLocationServices,
            }
        })
    )
    const onChange = (event: any, newValue: any) => {
        event.stopPropagation()

        homeTabSignal.value = newValue
    }

    const tabs = useMemo(() => {
        if (isGuestMode || disableLocationServices) {
            return homeTabs.filter((tab) => tab !== 'map')
        }

        return homeTabs
    }, [isGuestMode, disableLocationServices])

    return (
        <Tabs
            value={homeTabSignal.value}
            onChange={onChange}
            variant="fullWidth"
            indicatorColor="secondary"
            sx={{ minHeight: '44px', height: '44px' }}
        >
            {tabs.map((tab, index) => {
                const isSelected = homeTabSignal.value === tab
                const translationKey = getTranslationKeyFromHomeTab(tab)
                const tabIdentifier = getIdentifierFromHomeTab(tab)

                return (
                    <Tab
                        id={tabIdentifier}
                        disableRipple
                        disableFocusRipple
                        label={i18n.t(translationKey)}
                        value={tab}
                        key={tab}
                        sx={{
                            minHeight: '44px',
                            height: '44px',
                            textTransform: 'none',
                            fontFamily: isSelected
                                ? 'Inter-600-900'
                                : 'Inter-100-500',
                            fontWeight: 400,
                            color: getContrastYIQ(
                                ColoursObj.backgrounds.header
                            ),
                            '&.Mui-selected': {
                                color: getContrastYIQ(
                                    ColoursObj.backgrounds.header
                                ),
                            },
                        }}
                    />
                )
            })}
        </Tabs>
    )
}
